import {useQuery} from '@tanstack/react-query';
import {apiClient} from '../../../../../utils/api-client';
import {DocMetadata} from '../interface';

function getMetadataRequest(accession: string, globalVersion?: number) {
    return apiClient.get<DocMetadata>({
        path: `autocomplete-service/api/autocomplete/documents/${accession}/metadata`,
        query: {'global-version': globalVersion}
    });
}

export function useMetadataQuery(accession?: string, globalVersion?: number) {
    return useQuery({
        queryKey: ['ontology-tree-structure', accession, globalVersion],
        queryFn: () => getMetadataRequest(accession!, globalVersion),
        enabled: !!accession,
        refetchInterval: !globalVersion ? 3000 : undefined
    });
}
